// extracted by mini-css-extract-plugin
module.exports = {"note":"ErrorNotification_note__lgk47","noteText":"ErrorNotification_noteText__pzvbD","noteError":"ErrorNotification_noteError__1whze"};